import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "text-center min-w-150px" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_16 = { class: "text-center" }

import { ref, onMounted, provide } from "vue";
import UserService from "../services/UserService";
import SocialMediaFormModal from "./modal/SocialMediaFormModal.vue";
import { processKeysToCamelCase } from "@/core/services/api.client";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserContactInfo',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);
const socialMedias = ref<any>([]);
const socialMediaFormRef = ref<InstanceType<typeof SocialMediaFormModal>>();

const fetchData = async () => {
  isLoading.value = true;
  try {
    socialMedias.value = processKeysToCamelCase(
      await UserService.getSocialMediaInfo(props.partyId)
    );
    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const showSocialMediaForm = (_type, _item?) => {
  socialMediaFormRef.value?.show(props.partyId, _type, _item);
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("title.socialMedia")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showSocialMediaForm('create'))),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.addSocialMedia")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.appName")), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.accountId")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.connectId")), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.staffName")), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && socialMedias.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialMedias.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields." + item.name)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.account), 1),
                        _createElementVNode("td", null, _toDisplayString(item.connectId), 1),
                        _createElementVNode("td", null, _toDisplayString(item.staffName), 1),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (showSocialMediaForm('edit', item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ])
      ])
    ]),
    _createVNode(SocialMediaFormModal, {
      ref_key: "socialMediaFormRef",
      ref: socialMediaFormRef,
      onApplicationSubmitted: fetchData
    }, null, 512)
  ], 64))
}
}

})